export const custom = {
  /**
  * Idiomas disponibles ['es','en','pt','cat']
  */
  availableLangs: ['es'],

  /**
   * Idioma por defecto: ['es']
   */
  defaultLang: 'es',

  /**
   * Versión de la API: v2|v3
   */
  apiVersion: 'v3',

  /**
   * API key de conexión a la api definida en cada entorno
   * (debe ser el mismo en todos los servicios)
   */
  apiKey: '54ae6dcd-6a4a-4acb-8a16-30cec41f60fe',

  /**
   * URL de la app
   *
   * subdominio.dominio
   */
  appUrlDomain: 'chubbneckandneck.alares',

  /**
  * Nombre de la app
  */
  appName: 'Chubb',

  /**
  * Código de analytics 'G-XXXXXXXXXXX'
  * (Activado en pro, desactivado en pre y local)
  */
  analyticsId: 'G-NB6WMEDC7B',

  /** true o false. Define si es necesario hacer login para acceder a los contenidos */
  protected: false,

  /** Registro habilitado o deshabilitado */
  registration: false,
  videoCallsUrl: 'https://videollamada.vivofacil.com/?kid=AljJRe39SLEsWhMFg2pqTrA',
  mailTransport: 'alares',
  brandName: 'Alares',
  appUrlTld: 'es',
  /** true o false. Define si los formularios son para conciliación o no */
  conciliation: false
};
